module.exports = __webpack_public_path__ + "img/pro_three_3.fe01376a.jpg";